import { Button } from '@cgn/framework-ui-components/v2';
import React from 'react';
import PropTypes from 'prop-types';
import { vaiPaginaMieiPiani } from '../../PrenotaRichiamata/paginaMieiPiani';

const BottoneAttivaPianiEccellenza = ({ codiceUfficio }) => {
  const handleClick = () => {
    vaiPaginaMieiPiani(codiceUfficio);
  };

  return (
    <Button
      emphasis={Button.Emphasis.HIGH}
      onClick={handleClick}
      primary
    >
      Attiva piano eccellenza
    </Button>
  );
};

BottoneAttivaPianiEccellenza.propTypes = {
  codiceUfficio: PropTypes.string,
};

BottoneAttivaPianiEccellenza.defaultProps = {
  codiceUfficio: undefined,
};
export default BottoneAttivaPianiEccellenza;
